export function getCoptErrorTranslationString(errorType: string) {
  switch (errorType) {
    case 'less_than_equal':
      return { string: 'COMMON_MUST_BE_LESS_OR_EQUAL', code: 'le' };
    case 'greater_than_equal':
      return { string: 'COMMON_MUST_BE_GREATER_OR_EQUAL', code: 'ge' };
    case 'less_than':
      return { string: 'COMMON_MUST_BE_LESS_THAN', code: 'lt' };
    case 'greater_than':
      return { string: 'COMMON_MUST_BE_GREATER_THAN', code: 'gt' };
    case 'enum':
      return { string: 'COMMON_MUST_BE_ENUM_VALUE', code: 'expected' };
    case 'literal_error':
      return { string: 'COMMON_MUST_BE_ENUM_VALUE', code: 'expected' };
    case 'float_parsing':
      return { string: 'COMMON_MUST_CONTAIN_NUMBER', code: undefined };
    case 'extra_forbidden':
      return { string: 'COMMON_EXTRA_FORBIDDEN', code: undefined };
    default:
      undefined;
  }
}
